import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";

const ServiceJurusan = {}
ServiceJurusan.getDataAll = function (token) {

    return fetch({
        url: '/ref/jurusan',
        method: 'get',
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

export default ServiceJurusan;
